import React from "react";
import { PersistGate } from "redux-persist/integration/react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import MainRoutes from "./routes/MainRoutes";
import { store, persistor } from "./redux/Store/Store";
import { ToastContainer } from "react-toastify";
import { IntercomProvider } from "react-use-intercom";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <IntercomProvider appId={process.env.REACT_APP_INTERCOM_APP_ID}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MainRoutes />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
      </PersistGate>
    </Provider>
    </IntercomProvider>
);
